import bannerDesktop from '../../assets/banner-desktop.png';
import bannerMobile from '../../assets/banner-mobile.png';
import styles from './banner.module.scss';

export const Banner = () => {
  return (
    <div className={styles.bannerWrapper}>
      <div className={styles.bannerBg}></div>
      <div className={styles.bannerContent}>
        <img src={bannerDesktop} alt='主圖' className={styles.bannerCenter} />
        {/* <Counter /> */}
      </div>
      <div className={styles.bannerMobile}>
        <img
          src={bannerMobile}
          alt='行動版'
          className={styles.bannerMobileImg}
        />
        {/* <Counter /> */}
      </div>
    </div>
  );
};
